export class NumericalValueCountKeyValuePair {
	numerical_value: number;
	items_count: number;
}

export const NumericalValueCountKeyValuePair_EmptyEntity = [] as NumericalValueCountKeyValuePair[];